module.exports = __webpack_public_path__ + "img/Nerd.fb38bab0.gif";